// =====================================================================
// WeddingOS – InfoTip
// =====================================================================
// Kleiner "?" Button der beim Klick eine elegante Erklärung aufklappt.
// Wiederverwendbar in allen Gast-Pages.
// =====================================================================

import { useState } from "react";

export default function InfoTip({ short, steps }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ marginBottom: 20 }}>
      {/* Kompakte Zeile: kurze Info + "?" Button */}
      <div style={{
        display:       "flex",
        alignItems:    "center",
        justifyContent:"space-between",
        gap:           12,
        padding:       "12px 16px",
        background:    "var(--surface)",
        border:        "1px solid var(--line)",
        borderRadius:  open ? "var(--radius-md) var(--radius-md) 0 0" : "var(--radius-md)",
        transition:    "border-radius 0.2s",
      }}>
        <p style={{ margin: 0, fontSize: 13, color: "var(--ink-muted)", lineHeight: 1.4, flex: 1 }}>
          {short}
        </p>
        <button
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Anleitung schließen" : "Anleitung anzeigen"}
          style={{
            flexShrink:     0,
            width:          28,
            height:         28,
            borderRadius:   "50%",
            background:     open ? "var(--accent)" : "var(--bg-elevated)",
            border:         `1.5px solid ${open ? "var(--accent)" : "var(--line)"}`,
            color:          open ? "#fff" : "var(--ink-muted)",
            fontSize:       13,
            fontWeight:     700,
            cursor:         "pointer",
            display:        "flex",
            alignItems:     "center",
            justifyContent: "center",
            transition:     "background 0.2s, color 0.2s, border-color 0.2s",
            fontFamily:     "var(--font-body)",
          }}
        >
          {open ? "×" : "?"}
        </button>
      </div>

      {/* Aufgeklappte Detail-Anleitung */}
      {open && (
        <div style={{
          padding:      "18px 18px 16px",
          background:   "var(--bg-elevated)",
          border:       "1px solid var(--line)",
          borderTop:    "none",
          borderRadius: "0 0 var(--radius-md) var(--radius-md)",
          animation:    "wos-rise 0.2s ease",
        }}>
          <p style={{ margin: "0 0 14px", fontSize: 12, letterSpacing: "0.18em",
            textTransform: "uppercase", color: "var(--accent)", fontWeight: 600 }}>
            So funktioniert's
          </p>
          <ol style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: 10 }}>
            {steps.map((step, i) => (
              <li key={i} style={{ fontSize: 14, color: "var(--ink-muted)", lineHeight: 1.55, paddingLeft: 4 }}>
                <span style={{ color: "var(--ink)", fontWeight: 500 }}>{step.title}</span>
                {step.detail && (
                  <span style={{ color: "var(--ink-muted)" }}> — {step.detail}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
